module.exports = __webpack_public_path__ + "assets/MirrorSegDetailed.affe9e43ea4c946b8e08282b95e3df72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/MirrorSegDetailed.png
// module id = 539
// module chunks = 0